module.exports = __webpack_public_path__ + "static/media/subtopic.12e537de.svg";